module.exports = __webpack_public_path__ + "img/labelItem3@2x.768bf033.png";